import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { currencyCode } from 'Helpers/Geo/Country';
import useLineView from 'Hooks/useLineView';
import SpecialFormattedNumber from 'Components/Price/SpecialFormattedNumber';

export default function CheckoutPrice({ item, freeProduct }) {
  const out = useLineView(item);

  if (freeProduct) {
    return (
      <div className="price-container">
        <FormattedMessage id="checkout.checkout-price.free" defaultMessage="FREE" />
      </div>
    );
  }

  // appliedDiscount is set only for lines the voucher applies to. Test for a
  // finite value rather than > 0: a line the voucher covers in full has 0,
  // which must render as a zero price, not the undiscounted tier price.
  const pickAndMix = out?.pickAndMix;

  if (pickAndMix && Number.isFinite(pickAndMix.appliedDiscount)) {
    return (
      <div className="price-container">
        <SpecialFormattedNumber
          value={(pickAndMix.appliedDiscount) * item.quantity}
          style="currency"
        />
      </div>
    );
  }

  if (pickAndMix) {
    return (
      <div className="price-container">
        <SpecialFormattedNumber
          value={(pickAndMix.price) * item.quantity}
          style="currency"
        />
      </div>
    );
  }

  // order-calc: couponPrice is the module paid amount of the line, the amount
  // in the cart total. Show it as it is, with no recalculation, also for a
  // star deal that the voucher applies to. couponApplies is set only for a
  // line that the voucher applies to: a line that it covers in full has a
  // couponPrice of 0, which renders as a zero price.
  if (out && out.couponApplies) {
    return (
      <div className="price-container">
        <SpecialFormattedNumber
          className={out.isStarDeal ? 'btn btn-primary' : ''}
          value={(out.couponPrice / 100) * item.quantity}
          style="currency"
        />
      </div>
    );
  }

  if (out && out.isStarDeal) {
    return (
      <div className="price-container">
        <SpecialFormattedNumber
          className="btn btn-primary"
          value={(out.discountPrice / 100) * item.quantity}
          style="currency"
        />
      </div>
    );
  }

  if (item.type === 'bundle' && !item.is_srp_bundle) {
    return (
      <div className="price-container">
        <SpecialFormattedNumber
          value={(item.price[currencyCode] / 100) * item.quantity}
          style="currency"
        />
      </div>
    );
  }

  return (
    <div className="price-container">
      <SpecialFormattedNumber
        value={(out.discountPrice / 100) * item.quantity}
        style="currency"
      />
    </div>
  );
}

CheckoutPrice.propTypes = {
  item: PropTypes.shape({}).isRequired,
  freeProduct: PropTypes.bool,
};

CheckoutPrice.defaultProps = {
  freeProduct: false,
};
